import { TrustedCasinosDescription } from './trusted-casinos';
import { CryptoCasinosDescription } from './crypto-casinos';
import { NewCasinosDescription } from './new-casinos';
import { BlackListedCasinosDescription } from './blacklisted-casinos';

interface CollectionDescriptionProps {
  name: string;
}

export const CollectionDescription: React.FC<CollectionDescriptionProps> = ({
  name,
}) => {
  const descriptions: Record<string, React.ReactNode> = {
    'trusted-casinos': <TrustedCasinosDescription />,
    'crypto-casinos': <CryptoCasinosDescription />,
    'new-casinos': <NewCasinosDescription />,
    'blacklisted-casinos': <BlackListedCasinosDescription />,
  };

  return descriptions[name] || null;
};
